import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  信息新增
export function zhekouAdd (data) {
  return request({
    url: baseURL + 'zhekou/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function zhekouList (data) {
  return request({
    url: baseURL + 'zhekou/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function zhekouDelete (data) {
  return request({
    url: baseURL + 'zhekou/delete',
    method: 'post',
    data: data
  })
}
//  信息删除
export function zhekouUpdate (data) {
  return request({
    url: baseURL + 'zhekou/update',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/zhekou/index.js